<template>
  <div>
    <b-form class="b-layout" @submit.prevent="">
      <div class="flex">
        <label>{{ $t('tamanho-do-trianglo-px') }}</label>
        <b-input class="input-pentagro" v-model="size" type="number"></b-input>
      </div>

      <div class="flex">
        <label>{{ $t('espessura-da-seta-px') }}</label>
        <b-input 
          class="input-pentagro"
          type="number" 
          v-model="node.stroke"
          min="0.00"
        ></b-input>
      </div>

      <div class="flex">
        <label>{{ $t('distancia-da-seta-px') }}</label>
        <b-input 
          class="input-pentagro"
          type="number" 
          v-model.number="node.dif"
          min="0.00"
        ></b-input>
      </div>

      <div>
        <label for="color">{{ $t('cor-da-seta') }}</label>
        <b-form-select class="input-pentagro" v-model="color" name="color" id="color">
          <b-form-select-option 
            v-for="(c, i) in colorKeys" 
            :key="c"
            :value="colors[c]"
          >
            {{(i+1)+"-"+c}}
          </b-form-select-option>
        </b-form-select>
      </div>

      <div class="mt-2 arrow-set">
        <label>{{ $t('direcao-da-seta') }}</label>
        <b-button-group>
          <b-button :class="{ 'btn-success': node.direction == 'left' }" @click="setDirection" value="left">
            <b-icon class="icon" value="left" icon="arrow-left"></b-icon>
          </b-button>
          <b-button :class="{ 'btn-success': node.direction == 'up' }" @click="setDirection" value="up">
            <b-icon class="icon" value="up" icon="arrow-up"></b-icon>
          </b-button>
          <b-button :class="{ 'btn-success': node.direction == 'rigth' }" @click="setDirection" value="rigth">
            <b-icon class="icon" value="rigth" icon="arrow-right"></b-icon>
          </b-button>
          <b-button :class="{ 'btn-success': node.direction == 'down' }" @click="setDirection" value="down">
            <b-icon class="icon" value="down" icon="arrow-down"></b-icon>
          </b-button>
        </b-button-group>
      </div>

    </b-form>
  </div>
</template>

<script>
import { COLORS } from '../../utils/colors'

  export default {
    props: {
      node: {
        type: Object,
        default: null
      }
    },

    data() {
      return {
       colorKeys: Object.keys(COLORS).sort(),
       colors: COLORS,
       size: parseFloat(this.node.size) / 50,
       rotate: this.node.rotate,
       color: this.node.color,
      }
    },

    watch:{
      size() { this.node.size = parseFloat(this.size) * 50 },
      rotate() { this.node.rotate = this.rotate > 360 ? 360 : this.rotate },
      color() { this.node.color = this.color }
    },

    methods:{
      setDirection(value){
        if(value.target.value)
          this.node.setDirection(value.target.value)
        else if(value.srcElement.parentElement.value)
          this.node.setDirection(value.srcElement.parentElement.value)
      }
    },

    mounted(){ }
  }
</script>

<style scoped>

form{
  padding: 10px;
  color: #0009;
}

.arrow-set{
  display: flex;
  flex-direction: column;
}

.icon{
  color: #fff;
}

.flex{
  display: flex;
  align-content: center;
  justify-content: space-between;
}

.flex input{
  text-align: right;
  width: 100px;
  height: 30px;
}

</style>